import moment from 'moment';
import PayslipDetail from 'newModels/payslip-detail.js';

module.exports = Backbone.View.extend({
    tagName:   'div',
    className: 'payslip',

    initialize: function(options) {
        this.template = app.company.get('payslipSize') === 'A5' ?
            require('commons/templates/NewPayslip.ejs') :
            require('commons/templates/Payslip.ejs');
        this.options = _.defaults(options || {}, {
            payslipDetails:  null,
            companyLocation: null
        });

        this.options.payslipDetails.reset(
            _.sortBy(this.options.payslipDetails.models, function(item) {
                return -item.get('amount');
            }),
            {silent: true}
        );

        this.json = {};

        return this.options.model.getPayslipJSON()
            .then(data => {
                this.json = data;
                this.render();
            });
    },

    render: function() {
        const additions     = this.options.payslipDetails.findAdditions();
        const deductions    = this.options.payslipDetails.findDeductions();

        // 20200417 handling the "double EPF", which is caused by "additional"
        // EPF that is needed to create separate payroll detail for PCB
        // calculation. we need some hack right here to merge these items.
        const epfDeductions = deductions.findByType('epf');
        if (epfDeductions.length > 1) {
            const firstEpf = (
                epfDeductions.at(0) || new PayslipDetail({amount: 0})
            ).clone();

            const epfAmount = epfDeductions.reduce(
                (sum, model) => sum + model.get('amount'),
                0
            );
            firstEpf.set('amount', epfAmount);
            epfDeductions.forEach(model => deductions.remove(model));
            deductions.add(firstEpf);
        }
        const taxDeductions = this.options.payslipDetails.findTaxDeductions();
        const benefits      = this.options.payslipDetails.findBenefits();
        const nonTaxables = this.options.payslipDetails.findBenefitsNonTaxable();
        this.$el.html(this.template(Object.assign(this.json, {
            model:           this.model,
            payslipDetails:  this.options.payslipDetails,
            companyLocation: this.options.companyLocation,
            formattedSubmitDate : this.getFormattedSubmitDate(this.json.payroll),
            
            /* helping attributes */
            company:  app.company,
            employee: this.model.getEmployee(),
            address:  this.options.companyLocation.getAddress(),
            payroll:  this.model.getPayroll(),

            period:   this.model.getPeriod().month(),

            additions:     additions,
            deductions:    deductions,
            taxDeductions: taxDeductions.current(),
            benefits:      benefits.current(),
            nonTaxables:   nonTaxables.current(),

            employerEpfYtd: this.getEmployerYtdByType('epf'),
            employerSocsoYtd: this.getEmployerYtdByType('socso'),

            unpaidLeaveFootnote: this.getUnpaidLeaveFootnote(),
            mtdFootnote:         this.getMtdFootnote(),
            epfFootnote:         this.getEpfFootnote(),
            ytdFootnote:         {
                startMonth: (
                    new Date(this.model.getEmployee().get('commencementDate'))
                        .getFullYear() < this.model.getPeriod().year()
                ) ? 'January' : moment(
                        new Date(this.model.getEmployee().get('commencementDate'))
                    ).format('MMMM'),
                endMonth: this.model.getPeriod().format('MMMM'),
                year:     this.model.getPeriod().year()
            },
            overtimeFootnote: this.getOvertimeFootnote()
        })));

        return this;
    },

    getFormattedSubmitDate: function(payroll) {
        if (payroll && payroll.submittedDate && this.model.get('status') === 'done') {
            return moment(payroll.submittedDate.iso).format('MMM D, YYYY');
        }
        return this.model.getFormattedDate();
    },
    
    getEmployerYtdByType: function(type) {
        return (
            this.options.payslipDetails.findByType(type)
                .reduce((memo, model) => {
                    if (model.getPayrollItem().get('isNet')) {
                        return memo;
                    }

                    return memo + (model.get('ytd') || 0);
                }, 0) || 0
        );
    },

    getMtdFootnote: function() {
        const mtd = this.options.payslipDetails.findByType('mtd').find(d => {
            return d.getPayrollItem().get('subtype') !== 'custom';
        });
        const data = mtd ? mtd.get('additionalInformation') : false;
        const footnote = {
            employer: false,
            employeeAttributes: []
        };

        if (!mtd) {
            return false;
        }

        footnote.employer = (mtd.getPayrollItem().get('isNet') === false);

        if (!data || !data.employeeInfo) {
            footnote.employeeAttributes = this.model.getEmployee()
                .getTaxModifyingAttributes().join(', ');

            return footnote;
        }
        const subType = data.employeeInfo.residentSubType;

        if (data.employeeInfo.isDisabled) {
            footnote.employeeAttributes.push('Disabled');
        }

        if (data.employeeInfo.isResident) {
            footnote.employeeAttributes.push('Resident');
            if (subType === 1) { //knowledge worker
                footnote.employeeAttributes.push('Iskandar Knowledge Worker');
            } else if (subType === 2) { //ret exp program
                footnote.employeeAttributes.push('Returning Expert Program');
            }

        } else {
            footnote.employeeAttributes.push('Non-Resident');
        }
        if (subType === 3) {
            footnote.employeeAttributes.push('Freelancer');
        }

        switch (data.employeeInfo.marriedStatus) {
            case 1:
            case 2:
                footnote.employeeAttributes.push('Single');
                break;
            case 3:
                footnote.employeeAttributes.push('Divorced or Widowed');
                break;
            case 4:
                footnote.employeeAttributes.push('Married');
                footnote.employeeAttributes.push('Spouse Working');
                break;
            case 5:
                footnote.employeeAttributes.push('Married');
                footnote.employeeAttributes.push('Spouse Not Working');
                break;
            case 6:
                footnote.employeeAttributes.push('Married');
                footnote.employeeAttributes.push('Spouse Disabled');
                break;
        }

        if (data.employeeInfo.marriedStatus > 1) {
            if (
                !data.employeeInfo.children ||
                    !data.employeeInfo.children.length
            ) {
                footnote.employeeAttributes.push('No Dependent Children');
            } else if (data.employeeInfo.children.length === 1) {
                footnote.employeeAttributes.push(
                    '1 Child: ' +
                    this.getChildrenFootnote(data.employeeInfo.children)
                        .join(', ')
                );
            } else if (data.employeeInfo.children.length > 1) {
                footnote.employeeAttributes.push(
                    `${data.employeeInfo.children.length} Children: ` +
                    this.getChildrenFootnote(data.employeeInfo.children)
                        .join(', ')
                );
            }
        }

        footnote.employeeAttributes = footnote.employeeAttributes.join(', ');
        return footnote;
    },

    getChildrenFootnote: function(children) {
        const type = {
            0: 'None of the Categories',
            underage: 'Under 18 or In Education',
            inEducation: 'Over 18 - In Education (Diploma level)',
            inHigherEducation:
                'Over 18 - In Education (Degree level or higher)',
            disabled: 'Disabled',
            disabledInEducation: 'Disabled - In Higher Education'
        };
        const res = [];
        const groupedChildren = _.groupBy(children, item => {
            const category = item ? type[item.category] : type[0];
            return category + ' (' + item.pcbDeduction + '%)';
        });

        _.each(groupedChildren, (item, key) => {
            res.push(item.length + ' ' + key);
        });

        return res;
    },

    getEpfFootnote: function() {
        const footnote = {
            employeeRate:    0,
            employerRate:    0,
            employerContrib: 0,
            nonResident:     !this.model.getEmployee().get('isResident'),
            employeeExtraDeduction: 0,
            employerExtraDeduction: 0
        };

        const epfDetails = this.options.payslipDetails.findByType('epf')
            .filter(detail => (detail.get('amount') >= 0));

        if (epfDetails.length === 0) {
            return null;
        }

        const employeeEpf = _(epfDetails)
            .find(detail => detail.getPayrollItem().get('isNet'));
        const employerEpf = _(epfDetails)
            .find(detail => !detail.getPayrollItem().get('isNet'));

        if (employeeEpf) {
            const info = employeeEpf.get('additionalInformation') || {};
            footnote.employeeRate = ((info.rate || 0) * 100).toFixed(2);
            const employeeExtraDeductionAmount = (
                (info.extraDeductions || {}).employee || 0);
            if (employeeExtraDeductionAmount > 0) {
                footnote.employeeExtraDeduction =
                    employeeExtraDeductionAmount.toFixed(2);
            }
        }

        if (employerEpf) {
            const info = employerEpf.get('additionalInformation') || {};
            if (info.rate) {
                footnote.employerRate = (info.rate * 100).toFixed(2);
            } else {
                footnote.employerContrib = employerEpf.get('amount').toFixed(2);
            }
            const employerExtraDeductionAmount = (
                (info.extraDeductions || {}).employer || 0);
            if (employerExtraDeductionAmount > 0) {
                footnote.employerExtraDeduction =
                    employerExtraDeductionAmount.toFixed(2);
            }
        }

        return footnote;
    },

    getUnpaidLeaveFootnote: function() {
        const unpaidLeave = this.options.payslipDetails
            .findByType('unpaid_leave')
            .filter(detail => (
                detail.getPayrollItem().get('isGross') &&
                !detail.get('isAdditional') &&
                Object.keys(detail.get('additionalInformation') || {}).length
            ));

        if (!unpaidLeave.length) {
            return false;
        }

        // this block is used to render old style unpaid leaves
        if (unpaidLeave.length === 1 && !unpaidLeave[0].getAffectsItem()) {
            const leave = unpaidLeave.shift();
            const affectedDetails = this.options.payslipDetails
                .findAffectedByUnpaidLeave();

            return _.defaults(leave.get('additionalInformation') || {}, {
                method:    '',
                daysTaken: 0,
                monthDays: 0,
                details:   affectedDetails
            });
        }

        return unpaidLeave.map(leave => {
            const amount = this.options.payslipDetails.findByPayrollItem(
                leave.getAffectsItem()
            ).findAffectedByUnpaidLeave().getFullAmount();

            return _.defaults(leave.get('additionalInformation') || {}, {
                method:      '',
                daysTaken:   0,
                monthDays:   0,
                itemName:    leave.getAffectsItem().get('name'),
                amount:      amount || 0,
            });
        });
    },

    getOvertimeFootnote: function() {
        const overtime = this.options.payslipDetails
            .findByType('overtime');

        if (!overtime.length) {
            return false;
        }

        return overtime.map(detail => {
            return {
                name: detail.getPayrollItem().get('name'),
                hourlyWage: detail.get('additionalInformation').hourlyWage,
                factor: detail.get('additionalInformation').overtimeFactor
            };
        });
    }
});



// WEBPACK FOOTER //
// ./app/commons/views/Payslip.js